var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.935,
    height: 29.564,
    viewBox: "0 0 21.935 29.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:url(#b);}.b{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.81,
    y1: 0.281,
    x2: 0.215,
    y2: 0.613,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#085289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#086284"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-401.806 -1842.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M184.615,14.7c0,6.016-10.967,18.6-10.967,18.6S162.68,20.72,162.68,14.7a10.967,10.967,0,1,1,21.935,0Z",
    transform: "translate(239.126 1838.764)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.927,
    cy: 4.927,
    r: 4.927,
    transform: "translate(407.846 1848.084)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBlue);
export default __webpack_public_path__ + "static/media/pin-blue.b873e3c9.svg";
export { ForwardRef as ReactComponent };